<template>
  <footer class="main-footer">
    <p>Conheça mais sobre a Bluefit:</p>

    <ul>
      <li> <a href="https://www.linkedin.com/company/bluefit-academia/" target="_blank"> <img src="@/assets/images/linkedin.svg" aria-label="Linkedin" /> </a> </li>
      <li> <a href="https://www.instagram.com/bluefitacademia/" target="_blank"> <img src="@/assets/images/instagram.svg" aria-label="instagram" /> </a> </li>
      <li> <a href="https://www.facebook.com/bluefitacademia/" target="_blank"> <img src="@/assets/images/facebook.svg" aria-label="facebook" /> </a> </li>
      <li> <a href="https://x.com/bluefitacademia" target="_blank"> <img src="@/assets/images/twitter.svg" aria-label="twitter" /> </a> </li>
      <li> <a href="https://www.glassdoor.com.br/Vis%C3%A3o-geral/Trabalhar-na-Bluefit-Academia-EI_IE2609094.13,29.htm" target="_blank"> <img src="@/assets/images/g12.svg" aria-label="g12" /> </a> </li>
    </ul>

    <p class="powered-by">POWERED BY <a href="http://99jobs.com/" target="_blank"><strong>99jobs</strong></a></p>
  </footer>
</template>

<script>
export default {
  name: "mainFooter",
};
</script>

<style lang="scss" scoped>
  .main-footer{
    padding: 68px 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #050D9A;

    @media (max-width: 980px){
      flex-direction: column;
      justify-content: center;
    }

    div:first-of-type{
      display: flex;
      align-items: center;
    }

    ul{
      display: flex;
      margin-right: auto;
      margin: 0 auto 0 15px;
      padding: 0;

      @media (max-width: 980px){
        margin: 30px 0;
      }

      li{
        list-style: none;

        a{
          margin: 0 20px;

          img{
            height: 24px;
          }
        }
      }
    }

    p{
      
      font-size: 24px;
      font-weight: 400;
      line-height: 68px;
      letter-spacing: 0em;
      text-align: left;
      margin: 0;
      color: #FFFFFF;

      @media (max-width: 980px){
        line-height: 1.5;
        text-align: center;
      }
    }

    p.powered-by{
      
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.015em;
      text-align: left;
      a{
        color: inherit;
      }
    }
  }
</style>